export default class GuestCard {

  constructor(customer, card) {
    this.customer = customer;
    this.charging = false;
    this._refund = {
      amount: this.aggregateCharges(card.charges)
    };
    this._charge = {
      amount: undefined
    }
    Object.assign(this, card);
  }

  setAPI(api, company) {
    if(company) this.company = company;
    this.api = api;
  }

  get balance() {
    return this._charge._amount;
  }

  set balance(amount) {
    this._charge._amount = amount;
  }

  aggregateRefunds(refunds) {
    return refunds.map(refund => refund.amount).reduce((prev, refund) => prev + refund, 0)
  }

  aggregateCharges(charges) {
    return charges.map(charge => {
      const refunds = this.aggregateRefunds(charge.refunds);
      return charge.amount - refunds;
    }).reduce((prev, charge) => prev + charge, 0)
  }

  get totalCharged() {
    return this.aggregateCharges(this.charges)
  }

  refund(cb) {

    const promiseWhile = (data, condition, action) => {
      var whilst = (data) => {
        return condition(data) ?
          action(data).then(whilst) :
          Promise.resolve(data);
      }
      return whilst(data);
    };

    const _charges = this.charges.filter((c) => {
      return c.amount - this.aggregateRefunds(c.refunds) > 0;
    }).sort((a, b) => {
      return a.amount > b.amount;
    });
    
    if (this.api) {

      const charges = _charges[Symbol.iterator]();
      const req = this.api.req();
      const remaining = parseFloat(this._refund.amount);

      return promiseWhile(remaining, (r) => r > 0, (remaining) => {
        const charge = charges.next().value;
        const amount = charge.amount < remaining ? charge.amount : remaining;
        const Card = new req({
          id: charge.id,
          amount: amount,
        });
        return Card.$refund().then((res) => {
          const { error } = res;
          if(!error) {
            charge.refunds.push({
              "id": res.id,
              "charge": charge.id,
              "amount": amount,
              "date": moment.utc(new Date())
            })
            return res;
          } else {
            return error;
          }
        }).then((err) => {
          cb(); // save after each refund
          if (err) return remaining;
          return remaining - amount;
        });
      });

    } else {
      throw new Error('Card API not assigned, please call `setAPI`');
    }


  }

  charge(amount, cb) {

    const payload = {
      id: this.id,
      customer: this.customer,
      amount: parseFloat(amount)
    };

    this.charging = true;

    if(this.api) {
      const req = this.api.req(this.company);
      const Card = new req(payload);
      return Card.$charge().then((res) => {
        this.charging = false;
        const error = res.error;
        if(error) throw new Error(res.error);
        const charge = {
          refunds: [],
          id: res.id,
          amount: parseFloat(amount)
        };
        this.charges.push(charge);
        cb();
        return charge;
      }).catch(err => {
        this.charging = false;
      })
    } else {
      throw new Error('Card API not assigned, please call `setAPI`');
    }

  }

}



// WEBPACK FOOTER //
// ./client/assets/scripts/modules/card/card.js